import { mergeStyleSets } from '@uifabric/merge-styles';
import theme, { layout } from '../../theme.style';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  tabs: {
    marginBottom: pxToRem(26),
    selectors: {
      [layout.breakpoints.min.md]: {
        marginBottom: '2rem',
      },
      [layout.breakpoints.min.lg]: {
        marginBottom: pxToRem(24),
      },
    },
  },
  tabLink: {
    selectors: {
      '& .ms-Pivot .ms-Button:last-child': {
        float: 'right',
      },
    },
  },
  transactionsPaused: {
    marginBottom: pxToRem(24),
  },
  pendingApprovalText: {
    fontWeight: 400,
  },
  actionRequiredWrapper: {
    marginBottom: pxToRem(24),
    selectors: {
      ':empty': {
        display: 'none',
      },
    },
  },
  buttonContainer: {
    justifyContent: 'flex-end',
    display: 'flex',
    alignItems: 'center',
    gap: pxToRem(24),
  },
  exportToExcel: {
    marginBottom: pxToRem(1),
    color: theme.palette.themePrimary,
    fontSize: pxToRem(14),
    textDecoration: 'underline',
    selectors: {
      '&:hover': {
        backgroundColor: 'transparent',
        textDecoration: 'underline',
        color: theme.palette.themeDarker,
      },
      '.ms-Button-label': {
        fontWeight: 'normal',
        marginLeft: 0,
        marginRight: 0,
      },
    },
  },
  bulletedList: {
    paddingRight: pxToRem(10),
  },
  loadingSpinner: {
    marginTop: pxToRem(60),
  },
  downloadLink: {
    textDecoration: 'underline',
  },
});
